// extracted by mini-css-extract-plugin
export default {"rating":"yx-z","numberOfStars":"zx-z","count":"Ax-z","barGraphSpacing":"Bx-z","barGraph":"Cx-z"};